import { render, staticRenderFns } from "./HolidayType.vue?vue&type=template&id=af70eb20&"
import script from "./HolidayType.vue?vue&type=script&lang=js&"
export * from "./HolidayType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af70eb20')) {
      api.createRecord('af70eb20', component.options)
    } else {
      api.reload('af70eb20', component.options)
    }
    module.hot.accept("./HolidayType.vue?vue&type=template&id=af70eb20&", function () {
      api.rerender('af70eb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Holiday/HolidayType/HolidayType.vue"
export default component.exports